import { ColumnModel } from './column.model';
import { CaptionModel } from './caption.model';

export class GridModel {

   captions: Array<CaptionModel>;
   columns: Array<ColumnModel>;

   gridRef: string;
   active: number;

   constructor() { }

   public getCaption(id: number): CaptionModel {
      return this.captions.find(obj => obj.id === id);
   }

}
